import { axiosEduServer } from "../utils/configAxios";

export const crearHorarioGrupo = (data) => {
  return axiosEduServer.post('/horariogrupo', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarHorarioGrupo = (id, data) => {
  return axiosEduServer.put(`/horariogrupo/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarHorarioGrupo = (id) => {
  return axiosEduServer.delete(`/horariogrupo/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneHorarioGrupo = (id) => {
  return axiosEduServer.get(`/horariogrupo/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllHorarioGrupos = () => {
  return axiosEduServer.get('/horariogrupo').then(({ data }) => data).catch((err) => { throw err });
};

export const getHorarioGruposByGrupo = async (idGrupo) => {
  const all = await getAllHorarioGrupos();
  const isVisible = (hg) => {
    if (!hg) return false;
    if (hg.eliminado) return false;
    if (hg.fechaBaja) return false;
    if (hg.inhabilitado) return false;
    if (hg.habilitado === false) return false;
    if (hg.activo === false) return false;
    if (hg.estado != null) {
      const e = String(hg.estado).toUpperCase();
      if (["INHABILITADO", "ELIMINADO", "DESHABILITADO", "0", "FALSE", "F"].includes(e)) return false;
    }
    return true;
  };
  const norm = (hg) => {const h = hg.horario || {};
    return {id: hg.idHorarioGrupo,idHorario: hg.idHorario ?? h.idHorario ?? null,nroAula: hg.nroAula || "",
      dia: (h.dia && h.dia.nombre) || hg.dia?.nombre || null,
      horaInicio: h.horaInicio || hg.horaInicio || null,
      horaFin: h.horaFin || hg.horaFin || null, }; };return all.filter((hg) => hg.idGrupo === idGrupo).filter(isVisible).map(norm);
};